import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";

const UpdatePassword = React.lazy(
  () => import("../components/UpdatePassword/updatePassword"),
);
export function updatePassword() {
  return (
    <Route
      path="/update-password"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <LazySuspense>
              <UpdatePassword />
            </LazySuspense>
          </ProtectedRoute>
        </LazySuspense>
      }
    />
  );
}
